export const CONTACT_PHONE_DISPLAY = '(587) 889-7282';
export const CONTACT_PHONE_TEL = 'tel:+15878897282';

const WHATSAPP_NUMBER = '15878897282';

/** Builds a click-to-chat WhatsApp link pre-filled with a message, addressed to the business number. */
export function buildWhatsAppUrl(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
